var map = {
	"./bg-backcloth.png": "2a16",
	"./bg-clouds.png": "b291",
	"./bg-hills.png": "273f",
	"./prop-bird-left.png": "0f04",
	"./prop-bird-right.png": "c906",
	"./prop-bush-1-left.png": "87f8",
	"./prop-bush-1-right.png": "9dfd",
	"./prop-bush-2-left.png": "b88f",
	"./prop-bush-2-right.png": "a539",
	"./prop-bush-3.png": "56aa",
	"./prop-bush-4.png": "77f7",
	"./prop-glasses-left.png": "20dd",
	"./prop-glasses-right.png": "a1ae",
	"./prop-music-left.png": "03ee",
	"./prop-music-right.png": "df7f",
	"./prop-piano.png": "53c6",
	"./prop-rock-1-left.png": "0f5a",
	"./prop-rock-1-right.png": "2aeb",
	"./prop-rock-2-left.png": "6d2b",
	"./prop-rock-2-right.png": "8139",
	"./prop-rocket-left.png": "ff75",
	"./prop-rocket-right.png": "c3c4",
	"./prop-rose-left.png": "a2d5",
	"./prop-rose-right.png": "7e9f",
	"./prop-shopping-1-left.png": "0e17",
	"./prop-shopping-1-right.png": "0493",
	"./prop-shopping-2-left.png": "b39d",
	"./prop-shopping-2-right.png": "729a",
	"./prop-sign-1-right.png": "ae3c",
	"./prop-sign-2-left.png": "8aab",
	"./prop-sunflower-left.png": "9122",
	"./prop-sunflower-right.png": "72ec",
	"./prop-tree-1.png": "064b",
	"./prop-tree-2-left.png": "776b",
	"./prop-tree-2-right.png": "df21",
	"./prop-tv-1-left.png": "6792",
	"./prop-tv-1-right.png": "f513",
	"./prop-tv-2-left.png": "5db1",
	"./prop-tv-2-right.png": "a14c",
	"./prop-tv-3-left.png": "cfc6",
	"./prop-tv-3-right.png": "960d",
	"./prop-tv-4-left.png": "f7db",
	"./texture-brick-1-side.jpg": "c935",
	"./texture-brick-1-top-birthday.jpg": "1cfc",
	"./texture-brick-1-top-blank.jpg": "5502",
	"./texture-brick-1-top.jpg": "5ec2",
	"./texture-brick-2-side.jpg": "f729",
	"./texture-brick-2-top-birthday.jpg": "6ab7",
	"./texture-brick-2-top-blank.jpg": "6dd8",
	"./texture-brick-2-top.jpg": "e54a",
	"./texture-brick-3-side.jpg": "ee1d",
	"./texture-brick-3-top-birthday.jpg": "f82b",
	"./texture-brick-3-top-blank.jpg": "bbcb",
	"./texture-brick-3-top.jpg": "34a6",
	"./texture-grass.jpg": "77f5",
	"./texture-road.png": "9f81"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31d3";